import { User } from "@/types/user";
import { DataResponse } from "@/types/reponse-data";
import { ApiEndpointBuilder } from "@/services/api/types";
import { SearchRequest } from "@/types/search-request";

const searchUsersEndpoint = (builder: ApiEndpointBuilder) => {
  return builder.query<DataResponse<User>, SearchRequest>({
    query: request => {
      return {
        url: "/users/search",
        method: "POST",
        body: request,
      };
    },
    serializeQueryArgs: ({ endpointName }) => {
      return endpointName;
    },
    async onQueryStarted(_arg, api) {
      try {
        const { data } = await api.queryFulfilled;
        if (data) {
          api.updateCachedData(draft => {
            return draft;
          });
        }
      } catch (error) {
        console.error(error);
      }
    },

    forceRefetch({ currentArg, previousArg }) {
      return currentArg !== previousArg;
    },

    merge: (currentCache, newData) => {
      const cachePage = currentCache?.currentPage || 0;
      if (currentCache.data && newData?.currentPage && cachePage < +newData?.currentPage) {
        return {
          ...newData,
          data: [...currentCache.data, ...newData.data],
        };
      } else {
        return newData;
      }
    },

    providesTags: result => {
      return result?.data
        ? [
            ...result.data.map(item => ({
              type: "user",
              id: item.id,
            })),
            { type: "usersList" },
          ]
        : [{ type: "usersList" }];
    },
  });
};

export default searchUsersEndpoint;
